export default "__VITE_ASSET__DIfkXyT7__"